import { render, staticRenderFns } from "./DevicesDetails.vue?vue&type=template&id=13ca156a&scoped=true"
import script from "./DevicesDetails.vue?vue&type=script&lang=js"
export * from "./DevicesDetails.vue?vue&type=script&lang=js"
import style0 from "./DevicesDetails.vue?vue&type=style&index=0&id=13ca156a&prod&scoped=true&lang=css"
import style1 from "./DevicesDetails.vue?vue&type=style&index=1&id=13ca156a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ca156a",
  null
  
)

export default component.exports